import { render, staticRenderFns } from "./SelectSearchGbsHelps.vue?vue&type=template&id=16a2f627"
import script from "./SelectSearchGbsHelps.vue?vue&type=script&lang=ts"
export * from "./SelectSearchGbsHelps.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports